import { Typography } from '@mui/material';
import dayjs from 'dayjs';

import { TableCellCustom } from '@app/components/table';
import { StatusTag } from '@app/components';
import { RepairingStatus } from '@app/constants';
import { IAssetDetailsTransactionSchema } from '../types';

interface Props {
  row: IAssetDetailsTransactionSchema;
}

const AssestDetailsRow = (props: Props) => {
  const { row } = props;

  let statusValue: any;
  if (row?.status === 'Repairing') {
    statusValue = RepairingStatus.Repairing;
  } else if (row?.status === 'Repaired') {
    statusValue = RepairingStatus.Repaired;
  } else if (row?.status === 'Assigned') {
    statusValue = RepairingStatus.Assigned;
  }

  return (
    <>
      <TableCellCustom flex align="center">
        <Typography variant="body2">{row?.id ?? 'NA'}</Typography>
      </TableCellCustom>
      <TableCellCustom flex align="center">
        <Typography variant="body2">{row?.partName ?? 'NA'}</Typography>
      </TableCellCustom>
      <TableCellCustom flex align="center">
        <StatusTag status={RepairingStatus[statusValue]} />
      </TableCellCustom>
      <TableCellCustom flex align="center">
        <Typography variant="body2">{dayjs().format('YYYY-MM-DD HH:mm:ss A') ?? 'NA'}</Typography>
      </TableCellCustom>
      <TableCellCustom flex align="center">
        <Typography variant="body2">{row?.about ?? 'NA'}</Typography>
      </TableCellCustom>
    </>
  );
};

export { AssestDetailsRow };
